/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Datepicker } from 'baseui/datepicker';
import { withPermissionsProps } from '../../Utilities/hoc';
import { IDummyProps } from './types';
import { overrides as customOverrides } from './overrides';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { mergeOverrides } from 'baseui';
import { enGB } from 'date-fns/locale';

type EpoType = IDummyProps & withPermissionsProps;
export const View = React.forwardRef((props: EpoType, ref: any) => {
	const { overrides, size = 'default', formatString, locale = enGB, ...rest } = props;
	const HTMLAttrs = getHTMLAttributes(props);
	let InputOverrides = { ...overrides?.Input };
	let localOverrides = overrides;

	// We enforce an Input here. why? I suppose it comes from the legacy code
	if (overrides?.Input) {
		let { Input: any, ...restOverrides } = overrides;
		localOverrides = restOverrides;
	}

	const customOverridesResults = customOverrides(
		props,
		HTMLAttrs.dataProps,
		HTMLAttrs.ariaProps,
		HTMLAttrs.rest,
		InputOverrides,
	);

	return (
		<>
			<Datepicker
				{...rest}
				ref={ref}
				formatString={formatString ? formatString : props.timeSelectStart ? 'dd.MM.yyyy hh:mm' : 'dd.MM.yyyy'}
				overrides={overrides ? mergeOverrides(customOverridesResults, localOverrides as any) : customOverridesResults}
				locale={locale}
			/>
			{formatString}
		</>
	);
});
